import React from 'react';

/**
 * Infobulle comparaison cashflow — alignée sur le tableau « Ventilation cashflow » (Perso + Inc.).
 */
const CompareCashflowTooltip = ({ active, payload, labelA, labelB, formatCurrency }) => {
  if (!active || !payload?.length) return null;
  const row = payload[0]?.payload;
  if (!row) return null;

  const impactA = row.cashflowA ?? 0;
  const impactB = row.cashflowB ?? 0;
  const entityA = row.cashflowEntityA ?? 0;
  const entityB = row.cashflowEntityB ?? 0;
  const gap = impactB - impactA;
  const aligned = Math.abs(gap) < 1;

  return (
    <div className="bg-card border border-border rounded-lg p-3 shadow-lg text-xs max-w-xs" data-testid="compare-cashflow-tooltip">
      <p className="font-semibold mb-2">{row.year}</p>
      <p className="text-[0.65rem] uppercase tracking-wide text-muted-foreground mb-1">
        Impact cashflow (somme actifs)
      </p>
      <p>
        <span className="text-muted-foreground">{labelA}:</span>{' '}
        <span className="font-medium tabular-nums">{formatCurrency(impactA)}</span>
      </p>
      <p>
        <span className="text-muted-foreground">{labelB}:</span>{' '}
        <span className="font-medium tabular-nums">{formatCurrency(impactB)}</span>
      </p>
      <p
        className={`mt-1 font-medium tabular-nums ${aligned ? 'text-muted-foreground' : gap > 0 ? 'text-[var(--color-success)]' : 'text-[var(--color-destructive)]'}`}
      >
        {aligned ? 'Totaux identiques (comme le tableau débogage)' : `Écart : ${formatCurrency(gap)}`}
      </p>
      <p className="text-[0.65rem] text-muted-foreground mt-2 pt-2 border-t border-border">
        Cashflow net entité (référence) — {labelA}: {formatCurrency(entityA)} · {labelB}: {formatCurrency(entityB)}
      </p>
    </div>
  );
};

export default CompareCashflowTooltip;
